import * as React from 'react';
import { View, Text, Image } from 'react-native';
import { DEFAULT_VALUE } from './config';
import { Button } from '../Button';
import Style from './style';
export class EmptyStatus extends React.PureComponent {
    constructor(props) {
        super(props);
        this.style = new Style(props.needScale, props.size);
    }
    render() {
        const { type, needScale } = this.props;
        const data = Object.assign(Object.assign({}, (DEFAULT_VALUE[type || ''] || {})), this.props);
        const styleConfig = this.style.getStyle();
        const { imgUrl, title, text, buttonText, onPress, showButton, customStyle, size } = data;
        const { containerStyle, imageStyle, titleConStyle, titleTextStyle, textContentStyle, textStyle } = styleConfig;
        const { buttonBgColor } = customStyle || {};
        const etraBtnStyle = buttonBgColor
            ? { backgroundColor: buttonBgColor, borderColor: buttonBgColor }
            : {};
        return (<View style={containerStyle}>
                {imgUrl ? (<Image source={{ uri: imgUrl }} style={imageStyle}/>) : null}
                {title ? (<View style={titleConStyle}>
                        <Text numberOfLines={1} style={titleTextStyle}>
                            {title}
                        </Text>
                    </View>) : null}
                {text && React.isValidElement(text) ? text : null}
                {text && !React.isValidElement(text) ? (<View style={textContentStyle}>
                        <Text numberOfLines={2} style={textStyle}>
                            {text}
                        </Text>
                    </View>) : null}
                {showButton ? (<View style={{ marginTop: 20 }}>
                        <Button needScale={needScale} onPress={onPress} text={buttonText || '重试'} type="primary" size={size === 'small' ? 'mini_s' : 'small'} customStyle={etraBtnStyle}/>
                    </View>) : null}
            </View>);
    }
}
